import React from "react";
import { ChantSelect, HelpTooltip } from "../../../../../../CommonComponents";
import EventTranslations from "../../../../../../images/events-translations.png";
import { EVENTS_CONFIG } from "../utils/constants";
import "../styles/eventFormStyles.css";
import useContentFormParams from "../hooks/useContentFormParams";

export const ContentTypeSelector = ({ value, onChange }) => {
  const { formMode } = useContentFormParams();
  const options = Object.entries(EVENTS_CONFIG).map(([group, items]) => ({
    label: group,
    options: items.map((item) => ({
      label: item,
      value: item,
    })),
  }));

  return (
    <div className="event-form-field-wrapper" style={{ width: "100%" }}>
      <ChantSelect
        helpTooltip={<HelpTooltip imageSrc={EventTranslations} />}
        label="Content Type"
        required={true}
        value={value}
        placeholder="--Select Event Type--"
        options={options}
        onChange={onChange}
        disabled={formMode === "view"}
      />
    </div>
  );
};
